import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getBoolean'
})
export class GetBooleanPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    switch(value){
      case true:
      case "true":
      case 1:
      case "1":
        return true;
      default: 
        return false;
    }
  }

}
